import _jsx from "@babel/runtime/helpers/jsx";

var _App, _App2;

import React, { memo, Fragment } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { StaticRouter, BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { SUPPORTED_LOCALES } from 'utils';
import translationsRU from 'translations/ru.json';
import translationsUK from 'translations/uk.json';
import App from 'components/App';

if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill');

  require('@formatjs/intl-pluralrules/dist/locale-data/ru');

  require('@formatjs/intl-pluralrules/dist/locale-data/uk');
}

if (!Intl.RelativeTimeFormat) {
  require('@formatjs/intl-relativetimeformat/polyfill');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/ru');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/uk');
}

var translations = {
  ru: translationsRU,
  uk: translationsUK
};
var Root = /*#__PURE__*/memo(function (_ref) {
  var store = _ref.store,
      locale = _ref.locale,
      routerBasename = _ref.routerBasename,
      routerContext = _ref.routerContext,
      routerLocation = _ref.routerLocation,
      env = _ref.env,
      helmetContext = _ref.helmetContext;
  return /*#__PURE__*/_jsx(ReduxProvider, {
    store: store
  }, void 0, /*#__PURE__*/_jsx(IntlProvider, {
    locale: locale,
    defaultLocale: locale,
    messages: translations[locale],
    textComponent: Fragment
  }, void 0, env === 'server' ? /*#__PURE__*/_jsx(HelmetProvider, {
    context: helmetContext
  }, void 0, /*#__PURE__*/_jsx(StaticRouter, {
    location: routerLocation,
    context: routerContext,
    basename: routerBasename
  }, void 0, _App || (_App = /*#__PURE__*/_jsx(App, {})))) : /*#__PURE__*/_jsx(HelmetProvider, {}, void 0, /*#__PURE__*/_jsx(BrowserRouter, {
    basename: routerBasename
  }, void 0, _App2 || (_App2 = /*#__PURE__*/_jsx(App, {}))))));
});
Root.defaultProps = {
  routerContext: null,
  routerLocation: null,
  helmetContext: null
};
export default Root;